'use client';

import React from 'react';
import styled from 'styled-components';
import { theme } from '@/config/theme';

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SwitchWrapper = styled.div<{ $enabled: boolean; $isMultiToggle?: boolean; $size?: 'sm' | 'md' | 'lg' }>`
  position: relative;
  width: ${({ $size }) => $size === 'sm' ? '38px' : '44px'};
  height: ${({ $size }) => $size === 'sm' ? '20px' : '24px'};
  background: ${({ $enabled, $isMultiToggle, theme }) => 
    $isMultiToggle ? theme.colors.status.success : ($enabled ? theme.colors.status.success : theme.colors.status.error)
  };
  border-radius: ${({ $size }) => $size === 'sm' ? '10px' : '14px'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${({ $enabled, $isMultiToggle, theme }) => 
      $isMultiToggle ? theme.colors.status.successLight : ($enabled ? theme.colors.status.successLight : theme.colors.status.errorDark)
    };
  }
`;

const SwitchCircle = styled.div<{ $enabled: boolean; $size?: 'sm' | 'md' | 'lg' }>`
  position: absolute;
  top: ${({ $size }) => $size === 'sm' ? '1.5px' : '2px'};
  left: ${({ $enabled, $size }) => {
    if ($size === 'sm') {
      return $enabled ? '19px' : '2px';
    }
    return $enabled ? '22px' : '2px';
  }};
  width: ${({ $size }) => $size === 'sm' ? '17px' : '20px'};
  height: ${({ $size }) => $size === 'sm' ? '17px' : '20px'};
  background: ${theme.colors.white};
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: ${theme.shadows.sm};
`;

export interface SwitchProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  isMultiToggle?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({
  enabled,
  onChange,
  disabled = false,
  className,
  isMultiToggle = false,
  size = 'md',
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!enabled);
    }
  };

  return (
    <SwitchContainer className={className}>
      <SwitchWrapper 
        $enabled={enabled}
        $isMultiToggle={isMultiToggle}
        $size={size}
        onClick={handleToggle}
        style={{ 
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
      >
        <SwitchCircle $enabled={enabled} $size={size} />
      </SwitchWrapper>
    </SwitchContainer>
  );
};
